import React, { ReactNode, SetStateAction, Dispatch } from "react";

import { SelectOption } from "src/types";
import SelectLabel from "../SelectLabel/SelectLabel";

interface AccumulatedLabelsContentProps {
  multiValue: SelectOption[];
  emptyFieldPlaceholder: ReactNode;
  handleLabelClick: () => void;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  stackLabels?: boolean;
  readOnly?: boolean;
}

export default function AccumulatedLabelsContent({
  stackLabels,
  multiValue,
  emptyFieldPlaceholder,
  handleLabelClick,
  readOnly,
  setIsOpen,
}: AccumulatedLabelsContentProps) {
  const getLabelStyles = () => {
    if (!stackLabels) return {};

    if (multiValue.length === 1) {
      return { flexBasis: "100%" };
    }

    if (multiValue.length === 2) {
      return { flexBasis: "calc((100% - 4px) / 2)" };
    }

    return {
      flexBasis: "calc((100% - 8px) / 3)",
    };
  };

  const labels = stackLabels ? multiValue.slice(0, 5) : multiValue;

  return (
    <span
      onClick={readOnly ? undefined : () => setIsOpen(true)}
      className="select__value-wrapper"
    >
      {labels.map((item) => (
        <SelectLabel
          key={item.value}
          value={item}
          onClickHandler={handleLabelClick}
          emptyFieldPlaceholder={emptyFieldPlaceholder}
          style={getLabelStyles()}
          readOnly={readOnly}
        />
      ))}
      {stackLabels && multiValue.length > 5 && (
        <span className="select__value-wrapper-counter">
          +{multiValue.length - 5}
        </span>
      )}
    </span>
  );
}
